var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeckmarkircleStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2137 22.3853L29.1231 35.636L24.7684 30.0733C23.8617 28.9106 22.1817 28.708 21.0244 29.6173C19.8644 30.524 19.6591 32.2013 20.5684 33.3586L27.0511 41.644C27.5577 42.2893 28.3311 42.6653 29.1524 42.6653H29.1711C29.9951 42.6626 30.7737 42.2733 31.2724 41.6146L43.4564 25.6146C44.3497 24.4413 44.1231 22.772 42.9497 21.8786C41.7737 20.9853 40.1044 21.2146 39.2137 22.3853ZM32.0007 53.3335C20.238 53.3335 10.6673 43.7628 10.6673 32.0002C10.6673 20.2375 20.238 10.6668 32.0007 10.6668C43.7633 10.6668 53.334 20.2375 53.334 32.0002C53.334 43.7628 43.7633 53.3335 32.0007 53.3335ZM32.0007 5.3335C17.2727 5.3335 5.33398 17.2748 5.33398 32.0002C5.33398 46.7255 17.2727 58.6668 32.0007 58.6668C46.7287 58.6668 58.6673 46.7255 58.6673 32.0002C58.6673 17.2748 46.7287 5.3335 32.0007 5.3335Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeckmarkircleStroke);
export default __webpack_public_path__ + "static/media/СheckmarkСircleStroke.24a8ff3846c42ef553bf56192d49c9a6.svg";
export { ForwardRef as ReactComponent };